/* eslint-disable yoda */
import create from 'zustand';

const useUploaderStore = create((set) => ({
  media: [],
  setMedia: (value) => set({ media: value }),
  addImage: (image) => set((state) => {
    const isPhotoPresent = state.media.find(item => item.type === '' || item.type === 'cover');
    let newMedia = [];
    if (isPhotoPresent) {
      newMedia = [...state.media, image];
    } else {
      newMedia = [image, ...state.media];
    }
    newMedia = newMedia.map((item, index) => ({ ...item, sortOrder: index + 1 }));
    return ({
      media: newMedia
    });
  }),
  updateOrAddMedia: (mediaItem) => set((state) => {
    let itemExists = false;

    const newMedia = state.media.map(item => {
      if (item.id === mediaItem.id) {
        itemExists = true;
        return mediaItem;
      }
      return item;
    });

    if (!itemExists) {
      newMedia.push(mediaItem);
    }

    return { media: newMedia };
  }),
  removeMedia: (mediaId) => set((state) => ({
    media: state.media.filter(item => item.id !== mediaId)
  }))
}));

export default useUploaderStore;
